import styled from 'styled-components'

export const PaginationItem = styled.li`
  list-style: none;
  cursor: pointer;

  &[data-ar='true'] {
    transform: rotate(180deg);
  }

  &[data-click='true'] {
    cursor: not-allowed;

    a {
      cursor: not-allowed;
    }

    &:not([data-active]) {
      color: inherit;
    }

    &:active:not(:disabled):not([data-dots]) {
      transform: translateY(0px);
    }
  }

  & > a:active:not(:disabled):not([data-dots]) {
    transform: translateY(0px);
  }
`
